import React from 'react'
// import { generate_random } from '../../functions/functions'
import { Link} from 'react-router-dom'

function ServiceCard2(props) {
  // console.log(props.id)
  return (
    <>
    <div id={props.id}  data-aos-offset="300"
     data-aos-easing="ease-in-sine" data-aos={props.aos} className={props.index%2!==0?"ServiceCard2":"ServiceCard2 servicecard_mobile_view"}>

{
  props.index%2 !==0? <div className="icon_container">
  <i className={props.icon}></i>
</div>:""
}
    
    <div className="service_detials">
      <h2 className="heading">{props.title}</h2>
      <p>{props.detial}</p>
      <Link to="/contact" className="btn-1 services_contact_btn">Contact US</Link>

    </div>
    {
  props.index%2 ===0? <div className="icon_container">
  <i className={props.icon}></i>
</div>:""
}
   </div>
    </>
  )
}
ServiceCard2.defaultProps={
    title:"Web Development",
    detial:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Temporibus est tenetur explicabo commodi? Suscipit reiciendis accusamus id, in asperiores neque vitae ab perspiciatis aspernatur quidem, iste quam autem. Iure, illum. est tenetur explicabo commodi? Suscipit reiciendis accusamus id, in asperiores neque vitae ab perspiciatis aspernatur quidem, iste quam autem. Iure, illum. est tenetur explicabo commodi? Suscipit reiciendis accusamus id, in asperiores neque vitae ab perspiciatis aspernatur quidem, iste quam autem. Iure, illum.",
    icon:"fab fa-react",
    index:1,
    aos:"nothing"
    
}

export default ServiceCard2